import { IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import PortalModal from "../../Portals";
import {
  ButtonApproval,
  ButtonCancel,
  CloseModal,
  ContentDescription,
  ContentModal,
  DescriptionApproval,
  TextModal,
  TitleApproval,
} from "./ModalApprovalSurvey.styled";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import WarningIcon from "@material-ui/icons/Warning";
import { theme as themeConfig } from "../../themes/themes";

const ModalApprovalSurvey = ({ title, description, open, setOpen, fn }) => {
  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <span style={{ float: "left", margin: "0.5em", fontSize: "18px" }}>
            {"Alert"}
          </span>
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          <TitleApproval>{title}</TitleApproval>
          <ContentDescription>
            <WarningIcon style={{ color: themeConfig.primary.orange, marginTop: "0.5em" }} />
            <DescriptionApproval>{description}</DescriptionApproval>
          </ContentDescription>
        </TextModal>
        <div style={{ display: "inline-flex", margin: "auto", width: "100%" }}>
          <ButtonApproval onClick={() => fn(open)}>OK</ButtonApproval>
          <ButtonCancel onClick={() => setOpen(null)}>Cancel</ButtonCancel>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalApprovalSurvey;
